import MandatoryValidator from '../validators/mandatory.js';
import RegexValidator from '../validators/regex.js';
import RecaptchaValidator from '../validators/recaptcha.js';
import AtLeastOneCheckedValidator from '../validators/at-least-one-checked.js';
import CheckedInEachValidator from '../validators/checked-in-each.js';
import EmailAPIValidator from '../validators/email-api.js';
import DealerServiceValidator from '../validators/dealer-service.js';
import MandatoryRadioValidator from '../validators/mandatory-radio.js';
import MatchingValidator from '../validators/matching.js';
import NumberMinMaxValidator from '../validators/number-min-max.js';
import DateMinMaxValidator from '../validators/date-min-max.js';
import MandatoryIfValidator from '../validators/mandatory-if.js';

export default class ValidatorFactory {
    static get Validators() {
        return [
            MandatoryValidator,
            RegexValidator,
            RecaptchaValidator,
            AtLeastOneCheckedValidator,
            CheckedInEachValidator,
            EmailAPIValidator,
            DealerServiceValidator,
            MandatoryRadioValidator,
            MatchingValidator,
            NumberMinMaxValidator,
            DateMinMaxValidator,
            MandatoryIfValidator,
        ];
    }

    static build(input) {
        return this.Validators
            .filter((V) => V.applies(input))
            .map((V) => new V(input));
    }

    static isMandatory(v) {
        return v instanceof MandatoryValidator || v instanceof MandatoryRadioValidator;
    }
}
